import axios from "axios";
//import { API_BASE_URL } from "../Services/baseApiUrl";
import { API_BASE_URL, API_BASE_URL1 } from "../Services/baseApiUrl";
//const countryId =localStorage.getItem("country_Id");
import { toast } from "react-toastify";

const getToken = () => {
  return localStorage.getItem("token");
};

export const GetAllCountryDetails = async () => {
  try {
    const response = await axios.get(API_BASE_URL1 + `MasterDetails/GetAllCountries`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
 
  }
};

export const CreateCountryDeatails = async (countryData) => {
  try {
    const response = await axios.post(
      API_BASE_URL1 + `country/create`,
      countryData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    ); 

    return response;
  } catch (error) {
    throw error
 
  }
};

export const GetState = async () => {
  try {
    const response = await axios.get(API_BASE_URL1 + `/MasterDetails/GetAllStates`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
 
  }
};

export const CreateStateDetails = async (stateData) => {
  try {
    const response = await axios.post(
      API_BASE_URL1 + `state/create`,
      stateData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    ); 

    return response;
  } catch (error) {
    throw error
 ;
  }
};

export const GetCity = async () => {
  try {
    const response = await axios.get(API_BASE_URL1 + `MasterDetails/GetAllCities`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
 
  }
};

export const AddCityDetails = async (cityData) => {
  try {
    const response = await axios.post(API_BASE_URL1 +`MasterCreate/AddNewCity`, cityData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`
        },

      });

      console.log(response.data, 'ward respone create') 
      return response; 
    }
    catch (error) { 
     throw error;
 
    } 
};


export const GetStatebyID = async (countryId) => {
  try {
    const response = await axios.get(
      API_BASE_URL1 + `state/getStateByCountry/${countryId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
 
  }
};



export const UpdateCityDetails = async (cityData) => {
  try {
    const response = await axios.post(API_BASE_URL1 + `city/update`, cityData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },

      });

      console.log(response.data, 'zone update') 
      // toast.success('Zone updated Successfully!', {
      //     position: 'top-right',
      //     autoClose: 3000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      // })

    // if (!response.ok) {
    //   throw new Error("Failed to update zone");
    // }

    return response;
  } catch (error) {
   throw error  
 
   
  }
};

export const getCityById = async (id) => {
  try {
    const response = await axios.get(API_BASE_URL1 + `city/getById/${id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },

      });
    // console.log(response, 'response')
    return response;
  } catch (error) {
    throw error
 
  }
};

